import { useState, useCallback } from 'react'

/** Manages invoice checkbox selection state */
export function useKorektaSelection() {
	const [selectedInvoices, setSelectedInvoices] = useState(() => new Set())

	// Select or deselect all invoices
	const handleSelectAll = useCallback((checked, invoices = []) => {
		setSelectedInvoices(checked ? new Set(invoices.map(i => i._id)) : new Set())
	}, [])

	// Toggle single invoice selection
	const handleSelectInvoice = useCallback((invoiceId, checked) => {
		setSelectedInvoices(prev => {
			const next = new Set(prev)
			checked ? next.add(invoiceId) : next.delete(invoiceId)
			return next
		})
	}, [])

	// Clear all selected items
	const clearSelection = useCallback(() => setSelectedInvoices(new Set()), [])

	// Returns selection state for checkboxes
	const getSelectionState = useCallback(
		(invoices = []) => {
			const count = invoices.length
			const selectedCount = selectedInvoices.size
			return {
				isAllSelected: count > 0 && selectedCount === count,
				isIndeterminate: selectedCount > 0 && selectedCount < count,
			}
		},
		[selectedInvoices]
	)

	return {
		selectedInvoices,
		handleSelectAll,
		handleSelectInvoice,
		clearSelection,
		getSelectionState,
	}
}
